/*
 * @Author: cmchiu
 * @Date: 2023-05-05 14:12:33
 * @LastEditTime: 2023-05-05 14:13:39
 * @LastEditors: cmchiu
 * @Description:
 * @FilePath: \IACMP\IACMP_Client\src\api\project.js
 *
 */
import request from '@/utils/request'

export const getProjLs = data => {
    return request({
        url: '/Project/GetProjLs',
        method: 'post',
        data,
        withCredentials: true,
    })
}
